export default __webpack_public_path__ + "static/media/Group 11910.6eea8f65.svg";